/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetBalanceDetailResponse } from './GetBalanceDetailResponse';
import {
    GetBalanceDetailResponseFromJSON,
    GetBalanceDetailResponseFromJSONTyped,
    GetBalanceDetailResponseToJSON,
    GetBalanceDetailResponseToJSONTyped,
} from './GetBalanceDetailResponse';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetBalanceResponse
 */
export interface GetBalanceResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof GetBalanceResponse
     */
    balanceUnitId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof GetBalanceResponse
     */
    referenceNo: string;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetBalanceResponse
     */
    year: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetBalanceResponse
     */
    month: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceResponse
     */
    totalDebit: number;
    /**
     * 
     * @type {number}
     * @memberof GetBalanceResponse
     */
    totalCredit: number;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof GetBalanceResponse
     */
    user: IdNameResultOfint | null;
    /**
     * 
     * @type {Array<GetBalanceDetailResponse>}
     * @memberof GetBalanceResponse
     */
    details: Array<GetBalanceDetailResponse>;
    /**
     * 
     * @type {Date}
     * @memberof GetBalanceResponse
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the GetBalanceResponse interface.
 */
export function instanceOfGetBalanceResponse(value: object): value is GetBalanceResponse {
    if (!('balanceUnitId' in value) || value['balanceUnitId'] === undefined) return false;
    if (!('referenceNo' in value) || value['referenceNo'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('month' in value) || value['month'] === undefined) return false;
    if (!('totalDebit' in value) || value['totalDebit'] === undefined) return false;
    if (!('totalCredit' in value) || value['totalCredit'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('details' in value) || value['details'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function GetBalanceResponseFromJSON(json: any): GetBalanceResponse {
    return GetBalanceResponseFromJSONTyped(json, false);
}

export function GetBalanceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetBalanceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'balanceUnitId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['balanceUnitId']),
        'referenceNo': json['referenceNo'],
        'year': ApiUserTasksGetPageParameterFromJSON(json['year']),
        'month': ApiUserTasksGetPageParameterFromJSON(json['month']),
        'totalDebit': json['totalDebit'],
        'totalCredit': json['totalCredit'],
        'user': IdNameResultOfintFromJSON(json['user']),
        'details': ((json['details'] as Array<any>).map(GetBalanceDetailResponseFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function GetBalanceResponseToJSON(json: any): GetBalanceResponse {
    return GetBalanceResponseToJSONTyped(json, false);
}

export function GetBalanceResponseToJSONTyped(value?: GetBalanceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balanceUnitId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['balanceUnitId']),
        'referenceNo': value['referenceNo'],
        'year': ApiUserTasksGetPageParameterToJSON(value['year']),
        'month': ApiUserTasksGetPageParameterToJSON(value['month']),
        'totalDebit': value['totalDebit'],
        'totalCredit': value['totalCredit'],
        'user': IdNameResultOfintToJSON(value['user']),
        'details': ((value['details'] as Array<any>).map(GetBalanceDetailResponseToJSON)),
        'createdAt': value['createdAt'].toISOString(),
    };
}

